import React, { useMemo } from 'react';
import {
  Colors,
  Flex,
  IconHeart,
  IconHeartFilled,
  Typography,
} from '@banhala/ui-kit';
import { formatNumber } from 'shared/src/utils';
import { useOnPressLike } from '../hooks/useOnPressLike';

interface LikeButtonProps {
  initialIsLiked: boolean;
  likesCount: number;
}

export const LikeButton: React.FC<LikeButtonProps> = ({
  initialIsLiked,
  likesCount,
}) => {
  const { handlePress, isLiked } = useOnPressLike({ initialIsLiked });

  const likeCountText = useMemo(() => {
    const obj = formatNumber(likesCount);
    return `${obj.value}${obj.label}`;
  }, [likesCount]);

  return (
    <Flex
      gap={2}
      alignItems={'center'}
      padding={{ horizontal: 12 }}
      onPress={handlePress}
      testID={`상품상세찜 selected=${isLiked}`}
    >
      {isLiked ? (
        <IconHeartFilled size={24} fill={Colors.content_pink_primary} />
      ) : (
        <IconHeart size={24} fill={Colors.content_pink_primary} />
      )}
      <Typography type={'body4'} color={'content_pink_primary'}>
        {likeCountText}
      </Typography>
    </Flex>
  );
};